module.exports = __webpack_public_path__ + "assets/images/cosmote_2.97b9a6e28137d9b1a82c3de6052ade82.png";